import styled, { css } from 'styled-components';

export const ProfileIconsWrapper = styled.div<{ $isChartType?: boolean }>`
  ${({ $isChartType }) => css`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 0.25rem;
    flex-shrink: 0;

    ${
      $isChartType &&
      css`
        margin-top: -1.5rem;
      `
    }

    svg {
      height: 1.25rem;
      width: 1.25rem;
    }
  `}
`;
